import { Box, styled } from '@material-ui/core';
import { AIIcon } from '@setvi/shared/components/sicons';
import { TextColor } from '@setvi/shared/enums';
import { CSSProperties } from 'react';

const AIMatchBadge = styled(Box)(({ theme }) => ({
  padding: theme.spacing(1, 2),
  borderRadius: 99,
  width: 'fit-content',
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(1)
}));

const getBgColor = (val: ProductMatchProps['value']) => {
  if (val === 100) return '#1C8251';
  if (val >= 80) return TextColor.Green;
  // if (val > 50) return TextColor.Orange;

  return TextColor.Orange;
};

interface ProductMatchProps {
  value: number;
  fontSize?: CSSProperties['fontSize'];
  fontWeight?: CSSProperties['fontWeight'];
  padding?: CSSProperties['padding'];
  disabled?: boolean;
}

export const AIProductMatchBadge = ({
  value,
  disabled,
  fontSize = 14,
  fontWeight = 400,
  padding
}: ProductMatchProps) => (
  <AIMatchBadge
    style={{
      backgroundColor: disabled ? '#EEF0F2' : getBgColor(value),
      color: disabled ? '#AFBAC6' : 'white',
      fontSize,
      fontWeight,
      ...(padding != null && { padding })
    }}>
    <AIIcon fill={disabled ? '#AFBAC6' : '#fff'} style={{ fontSize }} />
    {value}%
  </AIMatchBadge>
);
